import React from 'react'
import PropTypes from 'prop-types'
import Container from './Container'
import Flower from '../assets/icons/flower.svg'
import BreadcrumbInHeader from '../components/BreadcrumbInHeader'
import InfoMiniBanners from './InfoMiniBanners'
import InfoBannerHeader from '../components/InfoBannerHeader'

function removeMorrisonsDaily(text) {
  const phraseToRemove = 'morrisons daily'
  const regex = new RegExp(phraseToRemove, 'gi')
  return text.replace(regex, '').trim()
}

const hoursOverride = [] //Override these stores hours with a different message

const ArticleHeader = ({
  currentCategory,
  currentPage,
  currentID,
  dateToday,
  region,
  category,
}) => {
  return (
    <div
      className={`relative py-6 md:pt-6 md:pb-10  ${
        category === 'McColls'
          ? 'bg-gradient-r-primary md:pb-6'
          : 'bg-gradient-r-primary'
      }`}
    >
      <Container>
        <section className="relative z-10 flex flex-wrap sm:flex-nowrap">
          <div className="w-full mb-2 sm:mb-0 sm:w-auto">
            <BreadcrumbInHeader
              storeType={category}
              category={currentCategory}
              currentPage={currentPage}
            />
            <h1 className="text-3xl leading-none text-white ">
              <span className="hidden">Details for:</span>
              {category !== 'McColls' ? (
                <>
                  <span className="block mb-4 font-semibold">
                    {currentCategory}
                  </span>
                  {hoursOverride.includes(currentID) ? (
                    <span className="block text-lg ">
                      {/* New Store Opening 12/12/2024 */}
                    </span>
                  ) : (
                    <span className="block text-lg ">{dateToday}</span>
                  )}
                  {/* HIDE OPENING TIMES  */}
                  {/* {currentID !== 382 ? (
                    <span className="block text-lg ">{dateToday}</span>
                  ) : null} */}
                </>
              ) : (
                <span className="flex-wrap items-center block -mb-2 sm:-mb-0 lg:-mt-2 md:flex">
                  <span className="flex flex-wrap items-center w-full mb-4 md:flex-nowrap">
                    <span className="inline-block mr-2 text-3xl font-bold text-white lg:text-4xl">
                      Morrisons
                    </span>
                    {'  '}
                    <span className="inline-block mr-2 text-3xl font-medium lg:text-4xl text-tertiary">
                      {' '}
                      Daily
                    </span>

                    <span className="block w-full text-2xl font-semibold lg:text-3xl md:w-auto ">
                      {' '}
                      {removeMorrisonsDaily(currentCategory)}
                    </span>
                  </span>
                  {hoursOverride.includes(currentID) ? (
                    <span className="block text-lg font-semibold">
                      {/* New Store Opening 26/01/2024 */}
                    </span>
                  ) : (
                    <span className="block text-lg font-semibold">
                      {dateToday}
                    </span>
                  )}
                </span>
              )}
            </h1>
            {(region === 'Morrisons Daily' ||
              region === 'Morrisons Select' ||
              category === 'Franchise') && (
              <span className="block mt-2 text-base font-semibold leading-tight sm:text-lg text-tertiary">
                Please note this is a franchise store run by a third party
              </span>
            )}
            {/* {category === 'McColls' && (
              <span className="block mt-2 text-base font-semibold leading-tight sm:text-lg text-mccolls-secondary">
                Please note - Some McColl&apos;s are franchise stores run by a
                third party
              </span>
            )} */}
          </div>
          <InfoMiniBanners store={currentID} />
          <InfoBannerHeader store={currentID} />
        </section>
      </Container>
      {category !== 'McColls' ?? (
        <div className="absolute top-0 bottom-0 left-0 right-0 w-full overflow-hidden">
          <Flower className="h-64 ml-auto mr-0 lg:h-auto" />
        </div>
      )}
    </div>
  )
}

ArticleHeader.propTypes = {
  currentCategory: PropTypes.string,
  region: PropTypes.string,
  category: PropTypes.string,
}

export default ArticleHeader
